import localforage from "localforage";

const FirebaseStore =  localforage.createInstance({
    name: 'firebaseLocalStorageDb',
    storeName: 'firebaseLocalStorage'
});

 export default FirebaseStore